module.exports = __webpack_public_path__ + "static/media/Mentorship-5.e558e958.jpg";